import { BasicTile } from "web/components/Tiles"
import { isNonEmptyArray } from "web/services/helpers"
import { Map } from "web/components"
import { MAP_STYLES } from "web/components/Map/MapConstants"
import useMapTile from "web/hooks/data/useMapTile"

export default function MapTile({
  overview,
  isTemplate,
  canEdit,
  subjectType,
  modifiedFromTemplate,
  tileFetchParams,
  tileSettingsModal,
}) {
  const tile = useMapTile({
    tileFetchParams,
    shouldResetOverview: !modifiedFromTemplate,
  })

  const hasLocations = isTemplate || isNonEmptyArray(tile.data.locations)

  function assetLngLatFn(x) {
    return [x.longitude, x.latitude]
  }

  function getStyleString(style) {
    return style === MAP_STYLES.streets ? "streets" : "satellite"
  }

  function handleLocationClick() {
    if (!isTemplate) {
      if (overview.type === "overview") {
        switch (subjectType) {
          case "deal":
            window.Turbo.visit(`${window.location.pathname}/deal_assets/map`)
            break
          case "company":
          case "portfolio":
            window.Turbo.visit(`${window.location.pathname}/deals/map`)
            break
          case "asset":
          case "deal_asset":
            window.Turbo.visit("./location/locations")
            break
          default:
            break
        }
      } else {
        switch (subjectType) {
          case "deal":
          case "asset":
          case "deal_asset":
            window.Turbo.visit("./map")
            break
          default:
            break
        }
      }
    }
  }

  async function handleZoomChange(zoomLevel) {
    if (tile.zoom === zoomLevel) return
    await tile.update({ overview_tile: { zoom: zoomLevel } })
  }

  async function handleStyleChange(style) {
    await tile.update({ overview_tile: { style: getStyleString(style) } })
  }

  async function handleOnHide() {
    await tile.destroy()
  }

  const dummyLocation = [
    {
      id: 439240771,
      street_address: {
        value: {
          value: "777 Bay Street",
        },
      },
      city: {
        value: {
          value: "Toronto",
        },
      },
      state: {
        value: {
          value: "Ontario",
        },
      },
      country: {
        value: {
          value: "Canada",
        },
      },
      postal_code: {
        value: {
          value: "M5B 2H4",
        },
      },
      longitude: "-79.38445590000001",
      latitude: "43.6604859",
      text: "777 Bay Street, Toronto, Ontario, M5B 2H4",
      is_account_scoped: true,
    },
  ]

  return (
    <BasicTile
      title={tile.name}
      id={tileFetchParams.id}
      canEdit={canEdit}
      handleOnHide={handleOnHide}
      handleTileSettings={tileSettingsModal}
    >
      {hasLocations ? (
        <div className="h-full w-full">
          <Map
            canEdit={canEdit}
            locations={isTemplate ? dummyLocation : tile.data.locations}
            onLocationClick={handleLocationClick}
            lngLatFn={assetLngLatFn}
            isStatic={true}
            canRecenterMap={true}
            zoom={tile.zoom}
            style={MAP_STYLES[tile.style]}
            savedMapCenter={null}
            handleMapCenterChange={null}
            handleZoomChange={handleZoomChange}
            handleStyleChange={handleStyleChange}
            buttonsLocation="bottom"
            showButtonsOnHover={true}
          />
          <div className="absolute left-2.5 top-2.5 z-10 mr-[90px] rounded-md bg-white px-1 py-0.5 text-lg font-bold text-neutral-3">
            {tile.name}
          </div>
        </div>
      ) : (
        <div className="flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7">
          There are no locations to map.
        </div>
      )}
    </BasicTile>
  )
}
